<template>
    <div>
        <b-row>
            <b-col v-for="(comms_payout_summary, index) in comms_payout_summaries" :key="comms_payout_summary.comms_payout_summary_id">
                <div v-if="index == 0">Pool Contribution</div>
                <div v-else>Advisory Pool Contribution</div>
                <table class="table table-bordered" width="100%">
                    <thead>
                        <tr>
                            <th class="bg-dark text-white py-2">#</th>
                            <th class="bg-dark text-white py-2">Pool</th>
                            <th class="bg-dark text-white py-2">Pool <br>Type <br>Code</th>
                            <th class="bg-dark text-white py-2">Frequency Code</th>
                            <th class="bg-dark text-white py-2">Pool Date Range</th>
                            <th class="bg-dark text-white py-2">Pool <br>Contribution <br>Percentage <br>(%)</th>
                            <th class="bg-dark text-white py-2">Pool <br>Contribution <br>Amount <br>(RM)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="!show_actual_revenue">
                            <tr v-for="(pool_contribution_detail, index) in comms_payout_summary.pool_contribution_details" :key="index">
                                <td class="py-2">{{ index+1 }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.pool_name }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.pool_type_code }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.frequency_code }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.pool_from_date }} - {{ pool_contribution_detail.pool.pool_to_date }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool_contribution_percentage | moneyFormatter }}</td>
                                <td class="py-2">RM {{ pool_contribution_detail.pool_contribution_amount | moneyFormatter }}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="(pool_contribution_detail, index) in comms_payout_summary.pool_contribution_details" :key="index">
                                <td class="py-2">{{ index+1 }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.pool_name }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.pool_type_code }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.frequency_code }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool.pool_from_date }} - {{ pool_contribution_detail.pool.pool_to_date }}</td>
                                <td class="py-2">{{ pool_contribution_detail.pool_contribution_percentage | moneyFormatter }}</td>
                                <td class="py-2">RM {{ pool_contribution_detail.actual_pool_contribution_amount | moneyFormatter }}</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
  props: ['comms_payout_summaries', 'show_actual_revenue'],
}
</script>